
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Info } from "lucide-react";
import type { ImportDataType } from "../types";

interface TemplateDownloadProps {
  dataType: ImportDataType;
}

export function TemplateDownload({ dataType }: TemplateDownloadProps) {
  const handleDownload = () => {
    let csvContent: string;
    
    if (dataType === "clients") {
      // Headers based on the Client type
      csvContent = "name,industry,website,contact_email,contact_phone,address,notes,status\n" +
        "Example Corp,Technology,www.example.com,contact@example.com,123-456-7890,\"123 Tech Street, Silicon Valley, CA\",Top priority client,active\n" +
        "Sample Inc,Healthcare,www.sample.com,info@sample.com,987-654-3210,\"456 Health Ave, Medical City, NY\",Potential expansion,pending";
    } else {
      // Headers based on the Candidate type
      csvContent = "first_name,last_name,email,phone,source,linkedin_url,experience_years,current_role,skills,notes,status\n" +
        "John,Doe,john.doe@email.com,123-456-7890,LinkedIn,linkedin.com/in/johndoe,5,\"Senior Developer at TechCorp\",\"React, TypeScript, Node.js\",Excellent frontend skills,new\n" +
        "Jane,Smith,jane.smith@email.com,987-654-3210,Referral,linkedin.com/in/janesmith,8,\"Tech Lead at WebCo\",\"Python, AWS, DevOps\",Strong leadership background,contacted";
    }
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${dataType}_template.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  return (
    <div className="space-y-4">
      <Alert>
        <Info className="h-4 w-4" />
        <AlertTitle>Download Template</AlertTitle>
        <AlertDescription>
          {dataType === "clients" ? (
            "Download our client template with fields for company details, contact information, and status tracking."
          ) : (
            "Download our candidate template with fields for personal information, experience, skills, and current status."
          )}
        </AlertDescription>
      </Alert>
      
      <Button 
        variant="outline" 
        onClick={handleDownload}
        className="flex items-center gap-2"
      >
        <Download className="h-4 w-4" />
        Download {dataType === "clients" ? "Client" : "Candidate"} Template
      </Button>
    </div>
  );
}
